import {Address} from '@components/common/Address';
import invoke from 'lodash.invoke';

const CC_TYPES = ['Visa', 'Mastercard', 'Amex', 'Discover'];

const WalletItem = props => {
    const {
        issuer,
        name,
        cardholder,
        paymentMethodType,
        lastFour,
        expirationDate,
        address,
        addressId,
        children,
        className = ''
    } = props;

    return (<div className={className}
                 onClick={() => invoke( props, 'onClick' )}>
            <div className="flex items-center px-4 py-3">
                {children}

                {CC_TYPES.includes( issuer ) && <img height="36"
                                                     className="w-12"
                                                     src={`/svg/components/credit-cards/${issuer.toLowerCase()}.svg`}
                                                     alt={issuer}/>}
                {!issuer && <img height="20" alt="Highradius" className="mr-1 h-5"
                                 src="https://images.ctfassets.net/wfptrcrbtkd0/4sTU0UjoQDMfhn28laq5Je/c090d2f1c06afb5ef53151cbe2ecde4c/highradius.svg"/>}

                {paymentMethodType === 'creditCard' ? <span className="flex-1 ml-2 relative">
                        <strong className="block">{issuer} ending in {lastFour}</strong>
                    {cardholder}
                    </span> : <span className="flex-1 ml-2 relative">
                        Bill me using my {name} account
                    </span>}

                {expirationDate && <span className="text-sm">Exp: {expirationDate}</span>}
            </div>

        {address && <div className="px-4 py-2 bg-white border-t-2 border-solid border-grey-lightest">
                <h3 className="mb-1 text-normal">Billing Address</h3>
                <Address {...address} />
            </div>}
        </div>);
};

export default WalletItem;
